import { useI18n } from 'vue-i18n'
import { MeasurementType, MeasurementTypes } from '@/configuration/measurements/measurement-types'
import { chooseLangString } from '@/utils/i18n-utils'
import { ParameterTypeDto } from '@/api/generated/HCA/api'
import { AnalysisType } from '@/configuration/analysis/analysis-types'
import { PARAMETER_UNIT_SEPARATOR } from '@/configuration/measurements/constants'

export const useMeasurementUtils = () => {
    const { t, locale } = useI18n()

    const getFormattedMeasurement = (parameter: ParameterTypeDto, analysisType: AnalysisType | MeasurementType, parameterTableNumber?: number | null, parameterUnit?: string | null) => {
        if (!parameterUnit) {
            return {
                label: chooseLangString(locale, parameter),
                value: parameter.id,
            }
        }

        const parameterId = `${parameter.id}${PARAMETER_UNIT_SEPARATOR}${parameterUnit}`
        const measurementTypeObj = MeasurementTypes.find((e) => e.value === analysisType)
        
        if (measurementTypeObj && 'tableSections' in measurementTypeObj && measurementTypeObj.tableSections) {
            const sectionKey = measurementTypeObj.tableSections[parameterTableNumber || 0]
            
            return {
                label: `${sectionKey ? t(sectionKey) : ''} ${parameterUnit} - ${chooseLangString(locale, parameter)}`,
                value: parameterId,
            }
        }

        return {
            label: `${chooseLangString(locale, parameter)} - ${parameterUnit}`,
            value: parameterId,
        }
    }

    return {
        getFormattedMeasurement,
    }
}
